import * as React from 'react';
import documentUrl from '../document-url';

export const termsVersion = 'developer_terms_20250818';

export const CURRENT_TERMS_URL = documentUrl(`${termsVersion}.pdf`);

interface TermsLinkProps {
  overrideTermsVersion?: string;
  style?: React.CSSProperties;
}

const TermsLink: React.FC<TermsLinkProps> = ({ overrideTermsVersion, style }) => {
  const url = overrideTermsVersion ? documentUrl(`${overrideTermsVersion}.pdf`) : CURRENT_TERMS_URL;
  return (
    <a style={style} href={url} target="_blank" rel="noopener noreferrer">
      Terms &amp; Conditions
    </a>
  );
};

export default TermsLink;
